import { Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { CreditCheckForm } from './CreditCheckForm';
import { useCreditCheck } from './useCreditCheck';

export type CreditCheckProps = Readonly<ReturnType<typeof useCreditCheck>>;

export function CreditCheck() {
	const props = useCreditCheck();
	const { goBack, t } = props;
	return (
		<ProgressBar page="credit-check">
			<Typography className="mb-5" TagName="h3">
				{t('sidebar_title', 'products')}
			</Typography>
			<div className="row">
				<div className="col-12 mb-2">
					<p>{t('sidebar_main', 'products')}</p>
					<hr className="mt-4 mb-4" />
					<CreditCheckForm {...props} />
					<Footer handlePrev={goBack} isDisabled={false} prev={t('back')} />
				</div>
			</div>
		</ProgressBar>
	);
}
